export default __webpack_public_path__ + "static/media/Pic2.fa7e1d3a.jpg";